<template>
    <div class="visit">
        <div class="visit-info" :style="`background-image: url(${info.bgUrl || 'https://staticwecom.beautyfarm.com.cn/20251126/logo_bg.png'})`">
            <div class="visit-title">本次走访信息</div>
            <div>
                <span>品牌</span>
                <span>{{ info.brandName }}</span>
            </div>
            <div>
                <span>调研问卷</span>
                <span>{{ info.questionnaireName }}</span>
            </div>
            <div>
                <span>走访轮次</span>
                <span>{{ info.visitRound }}</span>
            </div>
            <div>
                <span>走访时间</span>
                <span>{{ info.visitBeginTime }} 至 {{ info.visitEndTime }}</span>
            </div>
        </div>

        <van-search v-model="req.searchCond" placeholder="搜索编号、门店/门诊名称" @search="onSearch" />

        <div class="tabs">
            <div class="tabs-item" :class="{ active: it.value === currentTab }" v-for="(it, i) in tabs" :key="i" @click="onTab(it)">
                {{ it.label }}({{ it.sum }})
            </div>
        </div>
        <div class="quality-inspector" @click="onSelect">{{ currentInspector }}<van-icon name="arrow-down" /></div>

        <div class="visit-list">
            <div class="visit-item-hd">
                <div>编码&名称</div>
                <div>状态</div>
                <div>质检专员</div>
                <div>检查日期</div>
            </div>
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
                <div class="visit-item" v-for="(it, i) in visitList" :key="i" @click="onVisit(it)">
                    <div>
                        <div class="ellipsis">{{ it.storeId }}</div>
                        <div class="store ellipsis">{{ it.storeName }}</div>
                    </div>
                    <div>
                        <span v-if="it.visitStatus === 0">待走访</span>
                        <span v-if="it.visitStatus === 1" class="orange">走访中</span>
                        <span v-if="it.visitStatus === 2" class="green">已完成</span>
                    </div>
                    <div>{{ it.inspectorName || '--' }}</div>
                    <div>{{ it.checkDate || '--' }}</div>
                </div>
            </van-list>
        </div>

        <van-popup v-model="show" position="bottom">
            <van-picker show-toolbar :columns="inspectors" value-key="inspectorName" @confirm="onConfirm" @cancel="onCancel" />
        </van-popup>
    </div>
</template>

<script>
    import { queryTask, queryStores } from '@/api/crm'
    import { throttle } from 'lodash';
    import { getCookie } from '@/utils';
    import request from "@/utils/request";

    export default {
        name: 'Visit',
        data() {
            return {
                info: {},
                // tabs选项，包含全部、0待走访、1走访中、2已完成
                tabs: [
                    { label: '全部', value: '', sum: 34, name: 'total' },
                    { label: '待走访', value: 0, sum: 8, name: 'waitVisit' },
                    { label: '走访中', value: 1, sum: 10, name: 'visiting' },
                    { label: '已完成', value: 2, sum: 50, name: 'finished' },
                ],
                // 当前选中的tab，默认全部
                currentTab: '',
                // 列表加载状态
                loading: false,
                // 列表数据是否全部加载完成
                finished: false,
                error: false,
                // 走访列表数据
                visitList: [],
                show: false,
                // 质检员
                inspectors: [],
                currentInspector: '全部质检专员',
                // 请求参数
                req: {
                    page: 1, // 当前页码
                    limit: 10, // 每页条数
                    searchCond: '', // 查询条件
                    visitStatus: '', // 状态
                    inspector: '', // 走访员
                    qrCode: '',
                    // qrCode: '1991801523867410434' // 二维码 测试用
                },
            }
        },
        created() {
            this.req.qrCode = this.$route.query.qrCode
            this.init()
            this.queryTask()
        },
        methods: {
            init() {
                this.req.page = 1
                this.finished = false
                this.queryStores()
            },
            // 搜索框
            onSearch() {
                this.init()
            },
            // 点击状态
            onTab(it) {
                this.currentTab = it.value
                this.init()
            },
            onLoad() {
                this.queryStores()
            },
            // 分页查询列表
            queryStores: throttle(async function () {
                this.error = false;
                if (this.finished) return
                try {
                    const req = {
                        ...this.req,
                        visitStatus: this.currentTab
                    }

                    const { code, data, msg } = await queryStores(req)
                    if (code !== 0) throw msg

                    // 走访数量统计
                    this.tabs = this.tabs.map(it => {
                        it.sum = data[it.name]
                        return it
                    })
                    // 质检员列表
                    this.inspectors = [{ inspectorId: '', inspectorName: '全部质检专员' }, ...data.inspectors]

                    const list = data.visitStores.list || []

                    this.visitList = this.req.page === 1 ? list : [...this.visitList, ...list]

                    if (req.page * req.limit >= data.visitStores.total) {
                        this.finished = true;
                    }
                    this.req.page += 1

                } catch (error) {
                    this.error = true;
                    this.$toast(error + '')
                } finally {
                    this.loading = false;
                }
            }, 500),

            // 查询顶部走访卡片
            async queryTask() {
                const req = {
                    qrCode: this.req.qrCode
                }
                const { data } = await queryTask(req)
                this.info = data
            },
            // 打开质检员弹窗
            onSelect() {
                this.show = true
            },
            // 选择质检员
            onConfirm(it) {
                this.req.inspector = it.inspectorId
                this.currentInspector = it.inspectorName
                this.onCancel()
            },
            onCancel() {
                this.show = false
            },
            // 跳转问卷
            async onVisit(it) {
                if (it.visitStatus === 2) return
                const storeNo = it.storeId
                // const questionId = 'C-d5oJoBUKCKEBMjyG7d' // 测试问卷
                const empNo = localStorage.getItem("empNo") || getCookie("empNo") // 当前登陆人自己的empid
                
                if (empNo) {
                    this.safeJump(storeNo, empNo)
                    return
                }
                request({
                    url: "/my/getUserLogin",
                    method: "get",
                }).then((res) => {
                    if (res.code === 0) {
                        this.safeJump(storeNo, res.data.empNo)
                    }
                }).catch((error) => {
                   this.$toast(error + '')
                })
            },
            safeJump(storeNo, empNo) {
                const qrCode = this.req.qrCode
                const questionId = this.info.questionnaireId

                const url = window.SITE_CONFIG['webviewUrl'] + '/quesBefore?' +
                    'questionId=' + questionId +
                    '&storeNo=' + storeNo +
                    '&empNo=' + empNo +
                    '&qrCode=' + qrCode +
                    '&brandName=beautyfarm&accountNo=1'

                const a = document.createElement('a');
                a.href = url;
                a.target = '_self'; // 同窗口跳转，需要新窗口则改为_blank
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click(); // 触发原生点击
                document.body.removeChild(a); // 销毁标签
            }
        }
    }
</script>

<style lang='less' scoped>
    .visit {
        height: 100%;
        font-size: 30px;
        padding: 30px;
        color: #35434c;
        background-color: #fff;
        overflow-y: scroll;
    }

    .visit-info {
        margin-bottom: 20px;
        padding: 10px 20px 0;
        height: 312px;
        background-size: 100% 100%;
        border-radius: 4px;

        >div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 60px;
            font-size: 26px;

            >span:nth-of-type(1) {
                color: #606D75;
            }
        }

        .visit-title {
            position: relative;
            font-size: 28px;
            font-weight: 500;
            padding-left: 26px;

            &::before {
                position: absolute;
                left: 0;
                content: '';
                width: 6px;
                height: 6px;
                border: 6px solid #4375C9;
                border-radius: 50%;
            }
        }
    }

    .tabs {
        height: 100px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        color: #A0ACB5;

        .tabs-item {
            position: relative;
        }

        .active {
            color: #35434c;

            &::before {
                content: '';
                position: absolute;
                left: 50%;
                bottom: -16px;
                width: 50px;
                height: 8px;
                transform: translateX(-50%);
                background-color: #2FD0D5;
                border-radius: 4px;
            }
        }
    }

    .quality-inspector {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 26px;
        margin: 10px 0 30px;
    }



    .visit-item,
    .visit-item-hd {
        display: flex;
        align-items: center;
        height: 146px;
        font-size: 28px;
        border-bottom: 1px solid #D7D7D7;

        >div {
            flex: 1;
            text-align: center;

            &:nth-child(4) {
                flex: 1.3;
            }

            &:nth-child(1) {
                flex: 2;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }

        .store {
            margin-top: 10px;
        }
    }

    .visit-item-hd {
        height: 80px;
        font-size: 26px;
        color: #66757F;
        background-color: #FAFAFE;
        border: none;
    }

    .orange {
        color: #F7A63B;
    }

    .green {
        color: #2FD0D5;
    }
</style>


<style lang="less">
    .visit {
        .van-search {
            padding: 0;
            border-radius: 6px;
        }
    }

</style>
